import script from "./FormConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./FormConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./FormConfirmation.vue?vue&type=style&index=0&id=1b951d68&scoped=true&lang=css"

import exportComponent from "/home/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b951d68"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
